import { dialog } from "../../../../nq-component";
import BaseFormPresenter from "../../../../base/BaseFormPresenter";
import { liveQueryUseCase } from "../../../../usecases/livequery";

class WalkInApplicantFormPresenter extends BaseFormPresenter {
  constructor(view, upsertUseCase, getObjectUseCase, auditUseCase) {
    super();
    this.view = view;
    this.upsertUseCase = upsertUseCase;
    this.getObjectUseCase = getObjectUseCase;
    this.auditUseCase = auditUseCase;
  }

  onChangeObject(object) {
    this.change = object;
    this.object = object;
  }

  componentDidMount() {
    this.init();
    // this.subscribe();
    this.getObject();
  }

  // subscribe() {
  //   const query = {
  //     collection: "walkIn_applicants",
  //     where: {},
  //     include: ["all", "users", "employees"],
  //   };

  //   const insertSubscription = liveQueryUseCase().execute(query, "afterInsert");
  //   insertSubscription.on("create", (newObject) => {
  //     const currentObject = this.object;

  //     const updatedObject = {
  //       ...currentObject,
  //       [newObject.id]: newObject,
  //     };

  //     this.object = updatedObject;

  //     console.log("insert", this.object);
  //     this.view.setState({ object: updatedObject });
  //   });

  //   const updateSubscription = liveQueryUseCase().execute(query, "afterUpdate");
  //   updateSubscription.on("update", (updatedObject) => {
  //     this.object = updatedObject;
  //     console.log("update", this.object);
  //     this.view.setState({ object: updatedObject });
  //   });

  //   [insertSubscription, updateSubscription].forEach((subscription) => {
  //     subscription.on("error", (error) => {
  //       console.error("Subscription Error:", error);
  //     });
  //   });
  // }

  async getObject() {
    const collection = this.view.getCollectionName();
    const id = this.object.id || this.view.getObjectId();
    if (id) {
      const params = {
        include: [
          "character_references",
          "characterReferences.character_references",
          "employment_background",
          "employmentBackground.employment_background",
          "users",
          "employees",
          "recruiter.employee",
        ],
      };
      try {
        this.view.showProgress();
        this.object = await this.getObjectUseCase.execute(collection, id, {
          params,
        });
        this.view.hideProgress();
        this.view.setObject(this.object);
      } catch (error) {
        this.view.hideProgress();
        this.view.showError(error);
      }
    }
  }

  async getRecruiter(id) {
    if (!id) return null;

    const collection = "users";
    const params = { include: ["all"] };

    try {
      this.view.showProgress();
      return await this.getObjectUseCase.execute(collection, id, { params });
    } catch (error) {
      this.view.showError(error);
      return null;
    } finally {
      this.view.hideProgress();
    }
  }

  formatLastName(name) {
    if (!name || typeof name !== "string") return "";

    return name
      .split(" ")
      .filter((part) => part.trim().length > 0)
      .map((part) => part[0]?.toUpperCase() + ".")
      .join(" ");
  }

  async assignSubmit() {
    const collection = this.view.getCollectionName();
    const changeInfo = true;
    const getInfo = "alreadyClaimed";
    const recruiter = this.object?.recruiter?.username;
    const user = this.view.getCurrentUser();
    const id = this.object.id || this.view.getObjectId();
    const recruitersData = await this.getRecruiter(user.id);
    const formattedLastName = this.formatLastName(this.object?.lastName);

    const application = {
      name: `${this.object.firstName} ${formattedLastName}`,
      startDate: new Date().toISOString(),
      endDate: new Date(
        new Date().setDate(new Date().getDate() + 1)
      ).toISOString(),
      status: "waiting",
      recruiter: { id: recruitersData.id },
      employeeId: recruitersData.id,
      window: recruitersData?.window,
      recruiterFirstName: recruitersData.employee.firstName,
      recruiterMiddleName: recruitersData.employee.middleName,
      recruiterLastName: recruitersData.employee.lastName,
      positionApplied: this.object.positionApplied,
    };

    if (this.object?.recruiter) {
      dialog.close();
      this.view.assignSubmit(getInfo, recruiter);
      return;
    }
    if (id) {
      this.object.recruiter = { id: user.id };
      this.object.applicant = { id: this.object.applicant.id };
      const response = await this.upsertUseCase.execute(
        collection,
        this.object
      );

      const queue = await this.upsertUseCase.execute("queue", application);

      const auditObject = {
        user: { id: user?.id },
        action: "UPDATE",
        module: "Listings",
        description: "Application assigned to me",
        application_id: this.object?.id,
      };

      await this.auditUseCase.execute(auditObject);

      if (response && response.id && queue && queue.id) {
        dialog.close();
        this.view.setState({ object: this.object });
        this.view.assignSubmit(changeInfo);
      }
    }
  }
}

export default WalkInApplicantFormPresenter;
